import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="company-name">Key Element Dental Laboratory LLC</p>
        <p className="address">860 Greenbrier Circle #214</p>
        <p className="location">Chesapeake, Virginia 23320</p>
        <p className="phone">757-819-5550</p>
      </div>
    </footer>
  );
} 